import { gql } from '@apollo/client';
import { PersonDetailedFragment } from '../../fragments/person/PersonDetailed';

export const GetPersonWithAccount = gql`
  query GetPersonWithAccount($identifier: PersonIdentifierInput!) {
    person(identifier: $identifier) {
      ...PersonDetailed
    }
  }
  ${PersonDetailedFragment}
`;
